import { render, staticRenderFns } from "./LiveChart.vue?vue&type=template&id=c1dc0000&scoped=true&"
import script from "./LiveChart.vue?vue&type=script&lang=ts&"
export * from "./LiveChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1dc0000",
  null
  
)

export default component.exports